export default function isOnline(timestamp) {
  return timestamp.toMillis() >= new Date().getTime() - 5 * 60 * 1000;
}
